<!--
  课程管理 - 新增/编辑
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <el-card class="box-card">
      <el-alert
        :title="'操作说明：'+onGetNoDataTip()+'，在右侧显示的单元格内的科目可以拖拽调换。可从未排计划栏中将教学计划拖拽至课程表单元格中。课程表调整完毕请点击下方“发表课程表”按钮进行发布。'"
        type="warning" :closable="false">
      </el-alert>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="card-header tabsHeader">
        <el-tabs v-model="tabsIndex" type="card" @tab-click="onTabClick">
          <el-tab-pane label="班级排课调整" name="0"></el-tab-pane>
          <el-tab-pane label="教师排课调整" name="1"></el-tab-pane>
        </el-tabs>
        <div class="divSemesterBox">
          <el-select v-model="semesterId" placeholder="请选择学期" @change="onChangeSemester">
            <el-option v-for="item in optSemester" :key="item.semesterId" :label="item.name" :value="item.semesterId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="card-body">
        <el-row :gutter="20" class="elRowBody">
          <el-col :span="4" class="elLeftBody">
            <div class="divTreeCont">

              <el-input placeholder="输入关键字进行过滤" v-model="filterText">
                <el-button slot="append" icon="el-icon-refresh-right" @click="onFilterText()"></el-button>
              </el-input>
              <div class="divTreeBox" :style="'height:'+windowHeight+'px'">
                <el-tree :data="treeData" :props="defaultProps" ref="tree" style="margin-top:10px;" node-key="id"
                  @node-click="handleNodeClick" :accordion="true" :default-expand-all="false"
                  :render-content="renderContent" :filter-node-method="filterNode" :highlight-current="true">
                </el-tree>
              </div>



            </div>
          </el-col>
          <el-col :span="20" class="elRightBody">
            <!-- 未排计划 -->
            <div v-if=" tabsIndex==0">
              <div class="divTitleBox">未排计划栏</div>
              <div class="divOhterBox clearfix">
                <!-- <div class="btnLeft VerticalMid" @click="onBtnRight">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#fax-circle-left"></use>
                  </svg>
                </div> -->
                <!-- <div class="btnRight VerticalMid" @click="onBtnLeft">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#fax-circle-right"></use>
                  </svg>
                </div> -->
                <div class="divGroupBox">
                  <draggable v-model="NotItemData" group="itxst" class="add" :move="onMoveLeft" @add="onRightAdd"
                    @choose="onChooseTop($event)" @unchoose="onUnChooseTop">
                    <!-- boxWidth=》220*数量 -->
                    <transition-group style="display: flex; min-height: 80px; min-width: 400px; "
                      :style="'width:'+boxWidth+'px;'" class="clearfix">
                      <div class="itemBox itemTopBox" v-for="(item,index) in NotItemData" :key="index+'1'">
                        <div class="divNumberBox">
                          <div class="divNumber">{{item.surplus}}</div>
                        </div>
                        <div class="itemTitle">{{item.subject}}</div>
                        <div class="itemInfo">
                          <span class="spFontsTwo">{{item.teacher}}</span>
                        </div>
                        <div class="itemInfo" v-if="regNull(nowItemID)">
                          <span class="spFontsTwo">{{item.className}}</span>
                        </div>
                        <div class="itemInfo" v-if="!regNull(item.classroom)">
                          <span class="spTitle">场地</span>
                          <span class="spFonts">{{item.classroom}}</span>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>

            <div v-if="!regNullArray(itemData)">
              <table class="table table-bordered tableBox">
                <tr>
                  <td width="10%">
                    <div class="divTableTitleBox">
                      <div class="divWeek">星期</div>
                      <div class="divIndex">节次</div>
                    </div>
                  </td>
                  <td class="divWeekName" :width="90/optWeekTitle.length+'%'" v-for="(item,index) in optWeekTitle"
                    :key="index">
                    {{optWeekName[item.dayOfWeek]}}
                  </td>
                </tr>
                <tr v-for="(item,index) in itemData" :key="index">
                  <td class="divTimesBox">{{item.sectionIndex}}</td>
                  <td v-for="(list,indexTwo) in item.children" :key="indexTwo" class="tdSetBox"
                    :class="{'tdBgColor':list.status==1} ">
                    <div class="noCourseBox VerticalMid" v-if="list.status==2 && regNullArray(list.fix)">
                      <svg class="icon" aria-hidden="true">
                          <use xlink:href="#fax-times"></use>
                      </svg>
                    </div>
                    <!-- <div class="divNoArrange" v-if="list.forbidden">
                        <div class="divName">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#fax-exclamation-triangle-o"></use>
                          </svg>
                          已设置不排课
                        </div>
                      </div> -->
                    <!-- <div v-else> -->
                    <draggable v-model="list.fix" :group="onGetGroup(list)" chosenClass="chosen" filter=".forbid"
                      animation="100" :move="onMove" @add="onOperate($event,list)"
                      @choose="onChooseTable($event,list.fix,list.cellId)" @unchoose="onUnChooseTable">
                      <transition-group :style="groupHeight">
                        <div v-for="(it,indexThi) in list.fix" :key="indexThi+'left'" class="itemBox">
                          <div class="itemTitle">{{it.subject}}</div>
                          <div class="itemInfo" v-if="!regNull(it.teacher) && tabsIndex==0">
                            <span class="spFonts">{{it.teacher}}</span>
                          </div>
                          <div class="itemInfo" v-if="!regNull(it.teachingclass) && tabsIndex==1">
                            <span class="spFonts">{{it.teachingclass}}</span>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <!-- </div> -->
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <el-empty :image-size="200" :description="onGetNoDataTip()"></el-empty>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card-footer text-right" v-if="!isShowBtn">
        <el-button type="success" icon="el-icon-circle-check" @click="onRelease()">发布课程表</el-button>
      </div>
    </el-card>





  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import draggable from 'vuedraggable';
  export default {
    components: {
      draggable
    },
    data() {
      return {
        // 加载动画
        fullscreenLoading: false,
        // 学期
        optSemester: [],
        semesterId: null,

        itemData: [],
        NotItemData: [],
        // tabs 切换
        tabsIndex: '0',
        // 显示星期
        optWeekName: ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        optWeekTitle: [],

        filterText: '',
        // 左侧列表
        treeData: [],
        // 树型
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        nowItemID: '',
        groupHeight: 'min-height:80px; display: block;',

        otherData: [{
          id: 0
        }],

        groupTop: {
          name: 'itxst', //组名为itxst
          pull: true,
          put: true
        },
        marginLeft: 0,
        boxWidth: 0,
        nowInfo: null,
        isShowBtn: false,

        windowHeight: document.documentElement.clientHeight,
      };
    },
    created() {
      let that = this;

      that.fullscreenLoading = true;
      ajaxGet(that, '/api/admin/semester', null, function(resSemester) {
        that.fullscreenLoading = false;
        that.optSemester = resSemester;
        let temp = resSemester.find((item) => item.isCurrent == true);
        if (!regNull(temp)) {
          that.semesterId = temp.semesterId;
          that.isShowBtn = temp.published;
        } else {
          that.semesterId = resSemester[0].semesterId;
          that.isShowBtn = resSemester[0].published;
        }
        that.onGetClass(that);

        // 首次加载未排计划数据
        that.onGetnNotarrange(that);
      });
    },
    mounted() {
      let that = this;
      if (that.windowHeight < 400) {
        that.windowHeight = 600;
      }
    },
    watch: {
      /**
       * @description 动态搜索
       * @param {Object} val
       */
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      /**
       * @description 首次加载未排计划数据
       * @param {Object} that
       */
      onGetnNotarrange(that) {
        that.NotItemData = [];
        ajaxGet(that, `/api/admin/semesterplan/notarrange?semesterId=${that.semesterId}`, null, function(resArrange) {
          if (!regNullArray(resArrange)) {
            resArrange.forEach((item) => {
              item.className = item.classes.map(item => item.class).join();
              that.NotItemData.push(item);
            });
            that.boxWidth = that.NotItemData.length * 171;
          }
        });
      },
      /**
       * @param {Object} objItem
       */
      onGetGroup(objItem) {
        let tpParams = {
          name: 'itxst', //组名为itxst
          pull: true,
          put: false
        }
        if (objItem.status == 1) {
          tpParams.put = true;
        }


        return tpParams;
      },
      /**
       * @description
       */
      onUnChooseTop() {
        let that = this;
        // 设置成功后重置表格
        let tpParams = {
          id: that.nowItemID,
          value: that.nowItemID,
        }
        // setTimeout(function() {
        //   that.nowInfo = null;
        //   return false;
        // }, 1500);
        that.handleNodeClick(tpParams);
      },
      /**
       * @description 鼠标松开事件
       */
      onUnChooseTable() {
        let that = this;
        // 设置成功后重置表格
        let tpParams = {
          id: that.nowItemID,
          value: that.nowItemID,
        }
        setTimeout(function() {
          that.nowInfo = null;
          return false;
        }, 1500);
        that.handleNodeClick(tpParams);
      },
      /**
       * @description 未排计划栏拖拽事件
       * @param {Object} objItem
       */
      onChooseTop(objItem) {
        let that = this;
        if (!regNullArray(that.NotItemData)) {
          let planId = that.NotItemData[objItem.oldIndex].planId;
          ajaxGet(that, '/api/admin/semestertimetable/conflict/' + planId, null, function(resCell) {
            that.itemData.forEach((item) => {
              item.children.forEach((chil) => {
                if (!regNull(resCell.find(cell => cell == chil.cellId))) {
                  chil.status = 2;
                } else {
                  chil.status = 1;
                }
              });
            });
          });
        }
      },
      /**
       * @description 拖拽时触发事件
       * @param {Object} objItem
       */
      onChooseTable(objItem, objFix, objId) {
        let that = this;
        if (!regNullArray(objFix)) {
          let planId = objFix[objItem.oldIndex].planId;
          that.nowInfo = objFix[objItem.oldIndex];
          ajaxGet(that, '/api/admin/semestertimetable/conflict/' + planId, null, function(resCell) {
            let tempCell = resCell.filter(item => item != objId);

            that.itemData.forEach((item) => {
              item.children.forEach((chil) => {
                if (!regNull(tempCell.find(cell => cell == chil.cellId))) {
                  chil.status = 2;
                } else {
                  chil.status = 1;
                }
              });
            });
          });
        }
      },
      /**
       * @description 左侧按钮
       */
      onBtnLeft() {
        let that = this;
        if (that.marginLeft + 700 < that.boxWidth) {
          that.marginLeft += 170
        }
      },
      /**
       * @description 右侧按钮
       */
      onBtnRight() {
        let that = this;
        if (that.marginLeft - 170 > 0) {
          that.marginLeft -= 170
        } else {
          that.marginLeft = 0;
        }
      },
      /**
       * @description 发布课程表
       */
      onRelease() {
        let that = this;
        confirmDelete(that, '确认发布课程表吗？', function(res) {
          if (res == true) {

            that.fullscreenLoading = true;
            ajaxPost(that, '/api/admin/semestertimetable/publish/' + that.semesterId, null, function(res) {
              that.fullscreenLoading = false;
              if (res.result) {

                success(that, '课程表已发布成功，系統将跳转至总课表');
                setTimeout(function() {
                  that.$router.push({
                    path: "/Admin/EducationalAffairs/Timetable/After",
                  });
                  return false;
                }, 1500);

              }
            });
          }
        })
      },
      onRightAdd(objItem) {
        let that = this;

        if (!regNull(that.nowInfo)) {
          that.fullscreenLoading = true;
          ajaxDelete(that, '/api/admin/semestertimetable/' + that.nowInfo.timetableId, null, function(res) {
            that.nowInfo = null;
            let tpParams = {
              id: that.nowItemID,
              value: that.nowItemID,
            }
            that.handleNodeClick(tpParams);
            that.fullscreenLoading = false;
          });
        }



      },
      /**
       * @description 拖入事件
       * @param {Object} objItem
       */
      onOperate(objItem, objData) {
        let that = this;
        that.fullscreenLoading = true;
        let apiUrl = null;
        if (objData.fix.length > 1) {
          // 换课
          let twoIndex = objItem.newIndex != 0 ? 0 : 1;
          apiUrl =
            `/api/admin/semestertimetable/exchange?timetableId1=${objData.fix[objItem.newIndex].timetableId}&timetableId2=${objData.fix[twoIndex].timetableId}`;
          ajaxPutResult(that, apiUrl, null, function(res) {
            // 设置成功后重置表格
            let tpParams = {
              id: that.nowItemID,
              value: that.nowItemID,
            }
            that.handleNodeClick(tpParams);
            that.fullscreenLoading = true;
          });
        } else {
          if (!regNullArray(objData.fix[0])) {
            if (!regNull(objData.fix[0].subjectId)) {
              //排课
              ajaxPostResult(that, '/api/admin/semestertimetable/arrange/' + objData.fix[0].planId + '?cellId=' +
                objData.cellId, null,
                function(res) {
                  // 设置成功后重置表格
                  let tpParams = {
                    id: that.nowItemID,
                    value: that.nowItemID,
                  }
                  that.handleNodeClick(tpParams);
                  that.fullscreenLoading = true;
                })
            } else {
              // 调课
              apiUrl = '/api/admin/semestertimetable/transfer/' + objData.fix[0].timetableId + '?cellId=' +
                objData.cellId;
              ajaxPutResult(that, apiUrl, null, function(res) {
                // 设置成功后重置表格
                let tpParams = {
                  id: that.nowItemID,
                  value: that.nowItemID,
                }
                that.handleNodeClick(tpParams);
                that.fullscreenLoading = true;
              });
            }

          } else {
            warning(that, '请重新尝试设置！')
            // 设置成功后重置表格
            let tpParams = {
              id: that.nowItemID,
              value: that.nowItemID,
            }
            that.handleNodeClick(tpParams);
          }

        }

      },
      /**
       * @description move回调方法
       * @param {Object} e
       * @param {Object} originalEvent
       */
      onMove(e, originalEvent) {
        let that = this;
        // if (e.relatedContext.element.sectionsPerWeek == 0) return false;
        // if (e.relatedContext.list.length >= 2) return false;
        return true;
      },
      onMoveLeft(e, originalEvent) {
        let that = this;
        if (!regNullArray(e.relatedContext.list)) {
          return false
        }
        // if (e.relatedContext.element.sectionsPerWeek == 0) return false;
        // if (e.relatedContext.list.length >= 2) return false;
        return true;
      },
      /**
       * @description 无数据提示文字
       */
      onGetNoDataTip() {
        let that = this;
        switch (that.tabsIndex) {
          case '0':
            return '请点击左侧班级';
          case '1':
            return '请点击左侧教师';
        }
      },
      /**
       * @description 头部Tabs切换事件
       * @param {Object} objTab
       * @param {Object} objEvent
       */
      onTabClick() {
        let that = this;
        that.onFilterText();
        that.NotItemData = [];
        switch (that.tabsIndex) {
          case '0':
            // 加载班级
            that.onGetClass(that);
            break;
          case '1':
            // 加载教师
            that.onGetTeacher(that);
            break;
        }
      },
      /**
       * @description 树型点击事件
       * @param {Object} objItem
       */
      handleNodeClick(objItem) {
        let that = this;
        if (!regNull(objItem.value)) {

          if (objItem.value != '0000-0000' && objItem.value != '1111-1111') {
            that.nowItemID = objItem.id;
            let apiUrl = null;
            switch (that.tabsIndex) {
              case '0':
                apiUrl =
                  `/api/admin/semestertimetable/bysemesterclass?semesterId=${that.semesterId}&classId=${objItem.id}`;
                break;
              case '1':
                apiUrl =
                  `/api/admin/semestertimetable/bysemesterteacher?semesterId=${that.semesterId}&teacherId=${objItem.id}`
                break;
            }
            if (that.tabsIndex == 0) {
              that.NotItemData = [];
              ajaxGet(that, `/api/admin/semesterplan/notarrange?semesterId=${that.semesterId}&classId=${objItem.id}`,
                null,
                function(resArrange) {
                  if (!regNullArray(resArrange)) {
                    that.NotItemData = resArrange;
                    that.boxWidth = that.NotItemData.length * 150 + 200;
                  }
                })
            }
            ajaxGet(that, apiUrl, null, function(resData) {
              onGetDataOther(that, resData);
            });
          } else {
            that.nowItemID = null;
            if (that.tabsIndex == 0) {

              that.NotItemData = [];
              let apiUrl = '';
              if (objItem.value == '0000-0000') {
                apiUrl = `/api/admin/semesterplan/notarrange?semesterId=${that.semesterId}`
              } else {
                apiUrl = `/api/admin/semesterplan/notarrange?semesterId=${that.semesterId}&collegeId=${objItem.id}`
              }
              ajaxGet(that, apiUrl, null, function(resArrange) {
                if (!regNullArray(resArrange)) {
                  resArrange.forEach((item) => {
                    item.className = item.classes.map(item => item.class).join();
                    that.NotItemData.push(item);
                  });
                  that.boxWidth = that.NotItemData.length * 171;
                }
              })
            }
          }


        } else {
          that.nowItemID = null;
          that.itemData = [];
        }

      },
      /**
       * @description 重置搜索内容
       */
      onFilterText() {
        this.filterText = "";
      },


      /**
       * @description 获取班级
       * @param {Object} that
       */
      onGetClass(that) {
        that.fullscreenLoading = true;
        that.itemData = [];
        that.treeData = [];
        ajaxGet(that, '/api/admin/semesterplan/classbysemester?semesterId=' + that.semesterId, null, function(
          resClass) {
          that.fullscreenLoading = false;
          if (!regNullArray(resClass)) {
            that.treeData = [{
              id: null,
              value: '0000-0000',
              name: "班级信息",
              title: "班级信息",
              children: [],
            }];
            const res = new Map();
            let temp = resClass.filter((arr) => !res.has(arr.collegeId) && res.set(arr.collegeId, 1));
            temp.forEach((item) => {
              let tpClass = [];
              resClass.forEach((list) => {
                if (list.collegeId == item.collegeId) {
                  tpClass.push({
                    id: list.classId,
                    value: list.classId,
                    name: list.name,
                    title: list.name,
                  });
                }
              });
              that.treeData[0].children.push({
                id: item.collegeId,
                value: '1111-1111',
                name: item.college,
                title: item.college,
                children: tpClass,
              });
            });
          }
        });
      },
      /**
       * @description 获取教师
       * @param {Object} that
       */
      onGetTeacher(that) {
        that.fullscreenLoading = true;
        that.itemData = [];
        ajaxGet(that, '/api/admin/semesterplan/teacherbysemester?semesterId=' + that.semesterId, null, function(
          resTeacher) {
          that.fullscreenLoading = false;
          if (!regNullArray(resTeacher)) {
            that.treeData = [{
              id: null,
              value: null,
              name: "授课教师",
              title: "授课教师",
              children: [],
            }];
            resTeacher.forEach((item) => {
              that.treeData[0].children.push({
                id: item.userId,
                value: item.userId,
                name: item.name,
                title: item.name,
              });
            });
          }
        });
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },

      /**
       * @description 选择学期事件
       * @param {Object} objItem
       */
      onChangeSemester(objItem) {
        let that = this;
        that.tabsIndex = '0';
        that.nowItemID = null;
        that.NotItemData = [];

        let temp = that.optSemester.find(item => item.semesterId == objItem);
        if (!regNull(temp)) {
          that.isShowBtn = temp.published;
        }

        that.onGetClass(that);
        that.onGetnNotarrange(that);
      },
      /**
       * @description 去除重复值
       * @param {Object} arr
       */
      onArrUnique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.sectionIndex) && res.set(arr.sectionIndex, 1));
      },
      renderContent(h, {
        node,
        data,
        store
      }) {
        return ( < span class = "custom-tree-node" >
          <
          span style = "font-size:14px;" > {
            node.label
          } < /span></span > );
      },
    },
  };


  function onGetDataOther(that, objData) {
    if (!regNull(that.semesterId)) {
      // 获取单元格
      ajaxGet(that, '/api/admin/semestercell/' + that.semesterId, null, function(resData) {
        // 不排课规则
        // ajaxGet(that, '/api/admin/semesterrule/bysemesterclass', data, function(resRule) {

        that.itemData = [];
        let optlist = [];
        for (var it of resData) {
          it.fix = [];
          // 状态：用于排课，0：默认值，背景色为白，可排 1：背景为绿色，可排 2:背景白色，不可排
          it.status = 0;
          for (var it2 of objData) {
            // 设置单元格内的课程
            if (it.dayOfWeek == it2.dayOfWeek && it.sectionIndex == it2.sectionIndex) {
              it.fix.push({
                cellId: it.cellId,
                timetableId: it2.timetableId,
                planId: it2.planId,
                subject: it2.subject,
                classroom: it2.classroom,
                teacher: it2.teacher,
                teachingclass: it2.classes,
              });
            }
          }
        }
        that.fullscreenLoading = false;
        // 生成课表网格
        if (!regNullArray(resData)) {
          const res = new Map();
          let weekTitle = resData.filter((arr) => !res.has(arr.dayOfWeek) && res.set(arr.dayOfWeek, 1));

          that.optWeekTitle = weekTitle.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
          let temp = that.onArrUnique(resData);
          temp = temp.sort((a, b) => a.sectionIndex - b.sectionIndex);

          temp.forEach((item) => {
            let tpData = resData.filter((list) => {
              if (list.sectionIndex == item.sectionIndex) {
                list.dayOfWeek = setInt(list.dayOfWeek);
                return list;
              }
            });
            tpData = tpData.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
            that.itemData.push({
              sectionIndex: item.sectionIndex,
              children: tpData
            });
          });


          // 班级课表显示不排课规制
          // if (that.tabsIndex == 0) {
          //   let data = {
          //     semesterId: that.semesterId,
          //     classId: that.nowItemID,
          //   }
          //   ajaxGet(that, '/api/admin/semesterrule/bysemesterclass', data, function(r1) {
          //     for (var it of that.itemData) {
          //       for (var it2 of it.children) {
          //         for (var it3 of r1) {
          //           if (it2.cellId == it3.cellId) {
          //             it2.forbidden = true;
          //           }
          //         }
          //       }
          //     }
          //   })
          // }


        }


        // });
      });
    }
  }
</script>

<style scoped="scoped" lang="less">
  .divTitleBox {
    margin-bottom: 5px;
  }

  .divOhterBox {
    border: 1px solid #dddddd;
    margin-bottom: 20px;
    border-radius: 5px;
    position: relative;
    z-index: 1;

    .divGroupBox {
      overflow: auto;
      padding-bottom: 10px;
    }

    .btnLeft {
      position: absolute;
      left: -25px;
      top: 0;
      bottom: 0;
      width: 50px;
      z-index: 10;
      cursor: pointer;

      .icon {
        font-size: 32px;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }

    .btnRight {
      position: absolute;
      top: 0;
      right: -25px;
      bottom: 0;
      width: 50px;
      z-index: 10;
      cursor: pointer;

      .icon {
        font-size: 32px;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }


  }

  .chosen {

    width: 100px !important;

  }

  .itemBox {
    margin: 10px auto;
    // width: 150px;

    .divNumberBox {
      display: none;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .itemTitle {
      text-align: center;
      border: 1px solid #409eff;
      background-color: #409eff;
      color: #FFFFFF;
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 12px;
    }

    .itemInfo {
      font-size: 12px;
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #DCDFE6;
      border-left: 1px solid #DCDFE6;
      border-right: 1px solid #DCDFE6;
      background-color: #FFFFFF;

      .spTitle {
        padding-right: 2px;
        color: #909399;
      }

      .spFonts {
        padding-left: 2px;
        color: #303133;
      }

      .spFontsTwo {
        padding-left: 2px;
        color: #303133;
      }
    }
  }

  .itemTopBox {
    min-width: 150px;
    margin: 10px;
    cursor: pointer;
    position: relative;

    .divNumberBox {
      position: absolute;
      display: block;
      top: 20px;
      right: 20px;

      .divNumber {
        border: 1px solid #409eff;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        background-color: #FFFFFF;
        border-radius: 3px;
      }
    }
  }

  .divTreeCont {
    border: 1px solid #DDDDDD;
    padding: 15px;
    border-radius: 4px;
    position: relative;

    .divTreeBox {
      overflow: auto;
      min-width: 100px
    }
  }

  .tabsHeader {
    margin: -18px -20px;
    background-color: #f5f7fa;
    position: relative;

    .divSemesterBox {
      position: absolute;
      right: 5px;
      top: 5px;

      .spTitle {
        font-size: 14px;
      }
    }
  }



  .tableBox {
    td {
      border: 2px solid #aaa;
    }

    .tdSetBox {
      position: relative;
      text-align: center;
      cursor: pointer;
      height: 120px;

      .noCourseBox {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .icon{
          font-size: 72px;
          color: #bfbfbf;
        }
      }


      &:hover {
        background-color: #ecf5ff;
      }
    }

    .tdBgColor {
      background-color: #eafde2;

      &:hover {
        background-color: #eafde2;
      }
    }

    .divNoArrange {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: wrap;
      color: #303133;
      background-color: #EBEEF5;

      .icon {
        height: 30px;
        width: 100%;
      }

      .divName {
        font-size: 16px;
        color: #303133;
      }
    }

    .divTableTitleBox {
      background-image: linear-gradient(to bottom left, #a0cfff 50%, #aaa, #a0cfff 51%);
      height: 60px;
      position: relative;
      margin: -0.75rem;

      .divWeek {
        position: absolute;
        top: 5px;
        right: 5px;
        color: #000000;
      }

      .divIndex {
        position: absolute;
        bottom: 5px;
        left: 5px;
        color: #000000;
      }
    }

    .divWeekName {
      background-color: #a0cfff;
      text-align: center;
      font-size: 18px;
      padding-top: 5px;
      padding-bottom: 5px;
      vertical-align: middle;
      color: #000000;
    }

    .divTimesBox {
      background-color: #a0cfff;
      height: 60px;
      vertical-align: middle;
      text-align: center;
      color: #000000;
    }

  }
</style>


<style lang="less">
  // .elRowBody{
  //   display: table;
  //   .elLeftBody{
  //     display: table-cell;
  //         word-wrap: break-word;
  //         float: inherit;
  //   }
  //   .elRightBody{
  //     display: table-cell;
  //         word-wrap: break-word;
  //         float: inherit;
  //   }
  // }


  .tabsHeader {
    .el-tabs__item {
      height: 50px;
      line-height: 50px;
    }

    .el-tabs__header {
      margin: 0;
      margin-bottom: -1px;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background-color: #FFFFFF;
    }
  }
</style>
